// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preloader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--primary-color);
}
.preloader.relative {
  position: relative;
  border-radius: 8px;
}
.preloader.fixed {
  position: fixed;
  z-index: 200;
}
.preloader.absolute {
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/Preloader/Preloader.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAIA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gCCdK;ADWP;AAIE;EACE,kBAAA;EACA,kBAAA;AAFJ;AAIE;EACE,eAAA;EACA,YAAA;AAFJ;AAIE;EACE,kBAAA;AAFJ","sourcesContent":["@import '../../../styles/_variables';\r\n\r\n\r\n\r\n.preloader{\r\n  position: fixed;\r\n  top:0;\r\n  left:0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 100;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background: $main;\r\n  &.relative{\r\n    position:relative;\r\n    border-radius: 8px;\r\n  }\r\n  &.fixed{\r\n    position:fixed;\r\n    z-index: 200;\r\n  }\r\n  &.absolute{\r\n    position:absolute;\r\n  }\r\n}","$main: var(--primary-color);\r\n$accent:  var(--accent-color);\r\n$additional: var(--additional-color);\r\n$primary: #131313;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
